export default __webpack_public_path__ + "static/media/stamp.bd7a9bda.png";